import * as React from 'react';
import { FormikProps } from 'formik';

import { withStyles, createStyles, WithStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import Chip from '@material-ui/core/Chip';

import { getErrorAndTouched, IField } from './utils';

interface ISelectOptions {
  label?: string;
  value: string;
  disabled: boolean;
}

interface IProps {
  field: IField;
  form: FormikProps<any>;
  label: string;
  multiple?: boolean;
  options: ISelectOptions[];
  onChange?: () => void;
}

const styles = createStyles({
  chipContainer: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  chip: {
    margin: '2px'
  }
});

const FormikSelect = (props: IProps & WithStyles<typeof styles>) => {
  const { field, form, multiple, options, label, classes, ...other } = props;

  if (!field || !form) {
    return null;
  }
  const { error, touched } = getErrorAndTouched(form, field);

  const selectOptions = options.map(option => {
    return (
      <MenuItem
        key={option.label || option.value}
        value={option.value}
        disabled={option.disabled}
      >
        {option.label || option.value}
      </MenuItem>
    );
  });

  const handleBlur = (event: any) => {
    event.target.name = field.name;
    field.onBlur(event);
  };

  const errorText = touched && error && (
    <FormHelperText>{error}</FormHelperText>
  );
  return (
    <FormControl {...other} error={!!(touched && error)}>
      <InputLabel htmlFor={field.name}>{label}</InputLabel>
      <Select
        name={field.name}
        value={field.value}
        onChange={props.onChange || field.onChange}
        onBlur={handleBlur}
        input={<Input value={field.value} />}
        multiple={multiple}
        renderValue={
          multiple
            ? (selected: []) => (
                <div className={classes.chipContainer}>
                  {selected.map((value: string) => (
                    <Chip className={classes.chip} key={value} label={value} />
                  ))}
                </div>
              )
            : undefined
        }
      >
        {selectOptions}
      </Select>
      {errorText}
    </FormControl>
  );
};

export default withStyles(styles)(FormikSelect);



// WEBPACK FOOTER //
// ./src/common/formik/formik-select.tsx